<h2 class="pb-s">
  Newsletter
</h2>
<p>
  Lesen Sie hier die letzten drei Newsletter noch einmal in aller Ruhe nach und holen Sie sich Ihre spannenden Tipps &
  Tricks immer dann, wenn Sie diese brauchen.
</p>
<div class="row mt-l">
  <div class="col-md-2">
    <a target="_blank">
      <img src="../../assets/dummy/nl-1.jpg" class="img-border" />
    </a>
  </div>
  <div class="col-md-8">
    <strong>
      Wertvolle Tipps zur besseren Kommunikation im Team:
    </strong>
    <ul class="pl-s">
      <li>One Pager zum <strong>Download</strong></li>
      <li><strong>Kurzumfrage</strong> „Tipps zum Download“ + Überraschungsgeschenk</li>
      <li>Gestalten Sie mit – Nutzen Sie die <a>Feedback-Kachel</a></li>
      <li>Umfrage: Ihr Feedback zur aktuellen „be healthy!“ – jetzt Überraschung sichern</li>
    </ul>
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <a target="_blank">Newsletter Jetzt den Teamwork-Turbo zünden!, August 2024</a>
      </div>
      <div>
        <a class="download-button btn btn-primary btn-round"
           target="_blank"><span class="arrow-helper far fa-arrow-down"></span></a>
      </div>
    </div>
  </div>
</div>
<div class="row mt-l">
  <div class="col-md-2">
    <a target="_blank">
      <img src="../../assets/dummy/nl-2.jpg" class="img-border" />
    </a>
  </div>
  <div class="col-md-8">
    <strong>
      Exklusive Tipps gegen Stress & Druck im Job:
    </strong>
    <ul class="pl-s">
      <li>One Pager zum Download</li>
      <li>Beauftragte*n schnell & einfach mit der <a>An- /Ummeldemaske</a> ändern</li>
      <li>Umfrage: Ihr Feedback zur aktuellen „be healthy!“ – jetzt Überraschung sichern</li>
    </ul>
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <a target="_blank">Newsletter Entlasten Sie Ihren Apothekenalltag, Juli 2024</a>
      </div>
      <div>
        <a class="download-button btn btn-primary btn-round"
           target="_blank"><span class="arrow-helper far fa-arrow-down"></span></a>
      </div>
    </div>
  </div>
</div>
<div class="row mt-l">
  <div class="col-md-2">
    <a target="_blank">
      <img src="../../assets/dummy/nl-3.jpg" class="img-border" />
    </a>
  </div>
  <div class="col-md-8">
    <strong>
      Ihre Rolle im Zentrum des Erfolgs:
    </strong>
    <ul class="pl-s">
      <li>Warum Sie als Beauftragte*r wichtig sind und wie Sie ihr Team unterstützen können</li>
      <li>Nutzen Sie die Möglichkeit <a>Feedback</a> zu geben</li>
      <li>Mit dem <a>Marketing-Jahresplan</a> haben Sie die kommenden Monate im Blick</li>
      <li>Wie setzen Sie die Monatsaktion ein? Am Gewinnspiel teilnehmen</li>
      <li>Das „be healthy!“ verteilt sich genauso schnell wie warme Semmel</li>
    </ul>
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <a target="_blank">Newsletter Warum Sie (uns) wichtig sind, Mai 2024</a>
      </div>
      <div>
        <a class="download-button btn btn-primary btn-round"
           target="_blank"><span class="arrow-helper far fa-arrow-down"></span></a>
      </div>
    </div>
  </div>
</div>
